export const OPT_SEARCH_ALL = "all";
export const OPT_SEARCH_LANGUAGE = "language";
export const OPT_SEARCH_TRANSLATION = "translation";
export const OPT_SEARCH_BIBLE = "bible";
export const OPT_SEARCH_MEDIAID = "mediaId";
